<h1 mat-dialog-title>{{ error?.title }}</h1>

<mat-dialog-content>
  <p>{{ error?.message }}</p>

  @if (error?.details) {
  <section class="details">
    <div class="label">Details</div>
    {{ error?.details }}
  </section>
  }
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Ok</button>
</mat-dialog-actions>
